// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/wake-turbulence-categories.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/wake-turbulence-categories/wake-turbulence-categories.js';

mount([g0]);
